import { useMemo } from 'react'
import { Card, Spinner, Alert } from 'react-bootstrap'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from './highcharts-init'
import { useAdminAnalyticsBreakdown } from 'api/hooks/use-admin-analytics'
import EmptyState from 'shared/empty-state'

const MAX_VISIBLE_BARS = 15

const TopItemsBarChart = ({ title, subtitle, endpoint, params, categoryKey = 'key', color = '#1E2E48' }) => {
  const { data, isLoading, isError } = useAdminAnalyticsBreakdown({
    endpoint,
    params
  })

  const items = data || []

  const chartOptions = useMemo(() => ({
    chart: {
      type: 'bar',
      // Use scrollablePlotArea instead of the Highcharts Stock-only xAxis.scrollbar
      scrollablePlotArea: items.length > MAX_VISIBLE_BARS
        ? { minHeight: MAX_VISIBLE_BARS * 30 }
        : undefined
    },
    title: { text: '' },
    credits: { enabled: false },
    exporting: {
      enabled: true,
      filename: title,
      fallbackToExportServer: false,
      libURL: '',
      buttons: { contextButton: { enabled: false } }
    },
    xAxis: {
      categories: items.map((d) => d[categoryKey] || 'Unknown'),
      title: { text: null }
    },
    yAxis: {
      min: 0,
      title: { text: 'Count' },
      allowDecimals: false
    },
    tooltip: {
      pointFormat: 'Count: <b>{point.y:,.0f}</b>'
    },
    plotOptions: {
      bar: {
        dataLabels: { enabled: true, format: '{y:,.0f}' }
      }
    },
    legend: { enabled: false },
    series: [{
      name: 'Count',
      data: items.map((d) => d.count ?? d.value),
      color
    }]
  }), [items, title, categoryKey, color])

  return (
    <Card className="h-100">
      <Card.Header className="bg-white">
        <div className="fw-bold">{title}</div>
        {subtitle && <div className="text-muted" style={{ fontSize: '0.8rem' }}>{subtitle}</div>}
      </Card.Header>
      <Card.Body>
        {isLoading && <div className="text-center py-5"><Spinner /></div>}
        {isError && <Alert variant="danger">Failed to load data</Alert>}
        {!isLoading && !isError && items.length > 0 && (
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        )}
        {!isLoading && !isError && items.length === 0 && (
          <EmptyState />
        )}
      </Card.Body>
    </Card>
  )
}

export default TopItemsBarChart
